import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTabChangeEvent, MatTabGroup, MatTabsModule} from '@angular/material/tabs';
import {CareService} from '../../../admin-services/care.service';
import {finalize, take} from 'rxjs/operators';
import {CountryService} from '../../../../services/country.service';
import {TranslateService} from '@ngx-translate/core';
import {GlobalConstantsComponent} from '../../../../shared/global-constants/global-constants.component';
import {UserService} from '../../../../services/user-services/user.service';
import {AlertService} from 'src/app/services/alert.service';
import {AdminUserService} from '../../../admin-services/admin-user.service';
import {SellFilterPipe} from '../../../../pipes/sellFilter.pipe';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatPaginatorModule} from '@angular/material/paginator';
import {CheckImageUrlDirective} from '../../../../directives/check-image-url.directive';
import {CountUpModule} from 'ngx-countup';
import {DatePipe, NgClass, NgFor, NgIf, NgOptimizedImage} from '@angular/common';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {FormsModule} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {HelperService} from "../../../../services/helper.service";
import {MatSelectModule} from '@angular/material/select';
import {MatTooltip} from "@angular/material/tooltip";
import {environment} from "../../../../../environments/environment";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { IconComponent } from "../../../../shared/components/icons-svgs/icons-svgs.component";
import {NgbModal, NgbPopoverModule} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-attestation',
    templateUrl: './attestation.component.html',
    styleUrls: ['./attestation.component.scss'],
    standalone: true,
  imports: [MatSelectModule, MatIconModule, FormsModule, NgxIntlTelInputModule, NgFor, CountUpModule, MatTabsModule, NgIf, NgClass, CheckImageUrlDirective, MatPaginatorModule, MatFormFieldModule, MatInputModule, DatePipe, SellFilterPipe, NgOptimizedImage, MatTooltip, MatDatepickerModule, MatNativeDateModule, IconComponent, NgbPopoverModule]
})
export class AttestationComponent implements OnInit {

clearDates(): void {
    this.startDate = null;
    this.endDate = null;
    // Recharger les données sans filtre de date
    this.loadData();
}

loadData(): void {
    this.isLoadingDatas = true;
    this.careService.getPayouts('housing-certificate', this.dataStatus, 1, this.sellSearchText)
        .pipe(
            take(1),
            finalize(() => {
                this.isLoadingDatas = false;
            })
        )
        .subscribe((data) => {
            this.totalWaitingRefund = data.total;
            this.datas = data;
        });
}
  /**
   ******** Listing variables
   * @String
   * rawMediaURL        -> media url utilisée pour ouvrir les documents.
   * dataStatus         -> Store le statut de la tab active. Permet de faire la requête au back.
   * displayedCountry   -> Contient la nationalité du user dans un format lisible et compréhensible. Display purpose.
   * sellSearchText     -> Contient la valeur du filtre de recherche pour les ventes.
   * leadSearchText     -> Contient la valeur du filtre de recherche pour les leads.
   * docRefusalValue    -> Contient la raison du refus de document.
   *
   * @Array
   * displayTab         -> Contient le nom des tabs cliquables et permet de les afficher.
   * leadArray          -> Contient les leads.
   * kpiData            -> Contient les données KPI.
   *
   * @Boolean
   * isLoadingDatas     -> Change quand on change de tab et true on init.
   * isLoadingMore      -> Change quand on passe à la page suivante/précédente.
   * isSideOpen         -> Détermine si la popup de droite est ouverte ou non.
   * isRefusalOpen      -> Déterminé si la pop up de refus personnalité est ouverte ou non.
   *
   * @Any
   * datas              -> Contient les données souhaitées.
   * sideBoxItem        -> Item ouvert dans la popup de droite.
   *
   * @Number
   * totalWaitingRefund -> Nombre de demandes de remboursement en cours.
   */
  private rawMediaURL: string = GlobalConstantsComponent.rawMediaURL;
  private dataStatus: string = 'Pending-refund'
  displayedCountry: string;
  sellSearchText: string;
  docRefusalValue: string;

  displayTab: string[] = ['Demande de remboursement', 'Vendues', 'Remboursées', 'Remboursement refusé', 'Expirées'];

  isLoadingDatas: boolean = false;
  isLoadingMore: boolean = false;
  isSideOpen: boolean = false;
  isRefusalOpen:boolean = false;

  datas: any;
  sideBoxItem: any;
  typeDate: string = 'date de création';

  totalWaitingRefund: number = 0;

  @ViewChild('matTabGroup') matTabGroup: MatTabGroup;
  public isPendingRefund: boolean = false;
  public searchSub$ ;
  public isProd = environment.production;

  sortField: string = 'created_at';
  sortOrder: 'asc' | 'desc' = 'desc';

  startDate: Date | null = null;
  endDate: Date | null = null;


  constructor(
    private careService: CareService,
    private countryService: CountryService,
    private translateService: TranslateService,
    private userService: UserService,
    private alertService: AlertService,
    private adminUserService: AdminUserService,

  ) { }

  ngOnInit(): void {
    this.isLoadingDatas = true;
    const margingLayout = document.getElementsByClassName('page_content')[0];
    margingLayout.classList.add('my-0');
    this.careService.getPayouts('housing-certificate', this.dataStatus, 1)
      .pipe(take(1),finalize(() => {this.isLoadingDatas = false}))
      .subscribe((data) => {
      this.totalWaitingRefund = data.total;
      this.datas = data;
    });
  }
  ngOnDestroy(): void {
    const margingLayout = document.getElementsByClassName('page_content')[0];
    margingLayout.classList.remove('my-0');
  }

  /**
   * Activé quand on clique sur une attestation ou sur le bouton "voir +".
   * Ouvre la side box de droite.
   * Récupère & formate les informations pour les afficher dans la side box.
   * @param item : any -> attestation payout
   */
  openSideBox(item: any) : void {
    if (this.sideBoxItem) {
      this.isSideOpen = item.id !== this.sideBoxItem.id;
    } else {
      this.isSideOpen = true;
    }
    if (this.isSideOpen) {
      this.sideBoxItem = item;
      const nat = this.countryService.getCountry(this.sideBoxItem.user.nationality);
      this.displayedCountry = this.translateService.instant(nat.name);
      item.user['age'] = this.userService.calculateAge(item.user.birthdate);
      item.user['visaDocument'] = this.getDocument(item);
      if (item.datas) {
        item['certificate_datas'] = JSON.parse(item.datas);
        item['certificate_datas']['address1'] = item['certificate_datas'].address.split(',')[0];
        item['certificate_datas']['address2'] = item['certificate_datas']['address'].split(' ');
      }
    } else {
      this.closeSideBox();
    }
  }

  onDateChange(): void {
    if (this.startDate && this.endDate) {
        this.isLoadingDatas = true;
        const dateFilter = {
            dateField: this.getDateField(),
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate)
        };

        this.careService.getPayouts(
            'housing-certificate',
            this.dataStatus,
            1,
            this.sellSearchText,
            dateFilter
        ).pipe(
            take(1),
            finalize(() => {
                this.isLoadingDatas = false;
            })
        ).subscribe((data) => {
            this.totalWaitingRefund = data.total;
            this.datas = data;
        });
    }
}

  // méthode pour formater la date
private formatDate(date: Date): string {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}
// méthode de récuperation du field à chercher dans le json côté api
private getDateField(): string {
    const currentTab = this.displayTab[this.matTabGroup?.selectedIndex || 0];
    switch (currentTab) {
        case 'Remboursées':
          this.typeDate = 'Date de remboursement';
            return 'refundedDate';
        case 'Remboursement refusé':
          this.typeDate = 'Date de refus';
            return 'date';
        case 'Demande de remboursement':
          this.typeDate = 'Date de demande de remboursement';
            return 'askDate';
        default:
          this.typeDate = 'Date de création';
            return 'created_at';
    }
}

  /**
   * Permet de récupérer le document "VISA_REFUSED" du user pour le gérer dans le back care.
   *
   * @param item : any -> attestation payout
   * @private -> utilisée dans @openSideBox()
   */
  private getDocument(item: any) : any {
    return item.user.documents.reverse().find(d => d.name === 'VISA_REFUSED');
  }

  /**
   * Ferme la sidebox et clean les variables utilisées dedans
   */
  closeSideBox() : void {
    this.isSideOpen = false;
    this.sideBoxItem = null;
    this.displayedCountry = null;
    this.isRefusalOpen = false;
  }

  /**
   * Refresh les datas.
   * Revient sur la première tab automatiquement si c'est pour les ventes.
   *
   * @param element : string -> "attestation" || "lead"
   */
  refresh(element: string) : void {
    if (element === 'attestation') {
      this.isLoadingDatas = true;
      this.careService.getPayouts('housing-certificate', 'Pending-refund', 1)
        .pipe(take(1),finalize(() => {
          this.isLoadingDatas = false;
          this.changeDatas({index:0, tab:null});
          this.matTabGroup.selectedIndex = 0;
        }))
        .subscribe((data) => {
          this.totalWaitingRefund = data.total;
          this.datas = data;
        });
    }
  }

  /**
   * Activé quand on change de tab.
   * Permet de changer les datas à display selon l'index.
   *
   * @param e
   */
  changeDatas(e: MatTabChangeEvent) : void {
    this.isLoadingDatas = true;
    switch (e.index) {
      case 1: {
        this.dataStatus = 'Accepted';
        break;
      }
      case 2: {
        this.dataStatus = 'Refunded';
        break;
      }
      case 3: {
        this.dataStatus = 'Not-refunded';
        break;
      }
      case 4: {
        this.dataStatus = 'Expired';
        break;
      }
      default: {
        this.dataStatus = 'Pending-refund';
      }
    }

    let dateFilter;
    if (this.startDate && this.endDate) {
        dateFilter = {
            dateField: this.getDateField(),
            startDate: this.formatDate(this.startDate),
            endDate: this.formatDate(this.endDate)
        };
    }

    this.careService.getPayouts('housing-certificate', this.dataStatus, 1)
      .pipe(take(1),finalize(() => {this.isLoadingDatas = false}))
      .subscribe((data) => {
        this.datas = data
      });
  }

  sort(field: string, order: 'asc' | 'desc') {
    this.sortField = field;
    this.sortOrder = order;

    this.datas.datas.sort((a, b) => {
      let dateA = new Date(a.created_at).getTime();
      let dateB = new Date(b.created_at).getTime();

      return this.sortOrder === 'asc'
        ? dateA - dateB
        : dateB - dateA;
    });
  }


  /**
   * Activé quand on clique sur les flèches de la pagination
   * Permet de load les datas souhaitées selon e.pageIndex
   *
   * Doc du composant associé : https://material.angular.io/components/paginator/api
   *
   * @param e :{previousPageIndex: [number], pageIndex: [number], pageSize: [number], length: [number]}
   */
  loadPage(e) : void {
    this.isLoadingMore = true;
    this.careService.getPayouts('housing-certificate', this.dataStatus, e.pageIndex +1)
      .pipe(take(1),finalize(() => {this.isLoadingMore = false}))
      .subscribe((data) => {this.datas = data});
  }

  /**
   * Ouvre le document du user dans un nouveau tab s'il existe.
   * Activé quand on clique sur l'icone du document ou sur le bouton gris.
   * @param document
   */
  goToDocument(document): void {
    if(document){
      window.open(this.rawMediaURL + document.pivot.path + document.pivot.filename , "_blank");
    }
  }

  /**
   * Activé quand on change le statut d'un document (validé ou dans la pop de refus)
   * Si on clique sur validé, le document passe/reste en "Pending-refund" sinon il passe en "Pending-document".
   *
   * @param item : any -> attestation payout
   * @param docStatus : string -> statut du document
    * @param itemStatus : string -> change le statut de la vente.
   */
  updateDocumentStatus(item: any, docStatus : string, itemStatus : string): void {
    let data: any = {
      status : itemStatus,
      doc: null
    }
    if (item) {
      item.pivot.state = docStatus;
      data.doc = item;
      if(docStatus != 'validated'){
        let hubspotDatas = {
          user_id:item.pivot.user_id,
          campagne: '',
          source: '',
          medium: ''
        };

        this.adminUserService.setHubspotDealFromCare(6459040, 19276184, hubspotDatas).subscribe();
      }
    }
    this.userService.updatePayout(this.sideBoxItem.id, data).pipe(
      take(1),
      finalize(() => {
        this.refresh('attestation');
        this.closeSideBox();
      })
    ).subscribe();
  }


  makeRefund(status: string, refusedDatas? : any): void {
    this.isPendingRefund = true;
    if(!refusedDatas){
      refusedDatas = null;
    }
    else{
      refusedDatas = refusedDatas.value;
    }
    this.userService.updatePayout(this.sideBoxItem.id, {status: status, refusedDatas: refusedDatas}).pipe(
      take(1),
      finalize(() => {
        this.refresh('attestation');
        this.closeSideBox();
        this.isPendingRefund = false;
      })
    ).subscribe(
      (data: any) => {
        this.alertService.openSnackBar(data.message, 'snack-' + data.status);
        if(status == 'Not-refunded'){
          let hubspotDatas = {
            user_id:this.sideBoxItem.user_id,
            raison_de_refus_attestation: refusedDatas,
            campagne: '',
            source: '',
            medium: ''
          };

          this.adminUserService.setHubspotDealFromCare(6459040, 20522661, hubspotDatas).subscribe();
        }
        else{
          let hubspotDatas = {
            user_id:this.sideBoxItem.user_id,
            campagne: '',
            source: '',
            medium: ''
          };

          this.adminUserService.setHubspotDealFromCare( 6459040, 19276183, hubspotDatas).subscribe();
        }
      }
    );
  }

  calculateStatus(date: string): { text: string, class: string, time: string } {
    if (!date) return { text: 'pas de data', class: '', time: '' };

    const createdAt = new Date(date);
    const now = new Date();
    const limitDate = new Date();
    limitDate.setDate(now.getDay() - 45);

    const timeDifference = now.getTime() - createdAt.getTime();
    const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

    if (createdAt >= limitDate) {
      const daysRemaining = 45 - daysDifference;
      return {
        text: 'Valide',
        class: 'text-success',
        time: `${daysRemaining} jours restants`
      };
    } else {
      return {
        text: 'Expirée',
        class: 'text-danger',
        time: `${daysDifference - 45} jours depuis expiration`
      };
    }
  }

  public goToUserPage():void {
    const url = window.location.protocol + '//' + window.location.host
    window.open( url + '/admin/users/' + this.sideBoxItem.user.id, '_blank');
  }


  getAvatar(user){
    if (user && user.avatar && user.avatar !== 'default-avatar.png') {
      return user.avatar;
    }
    return 'assets/img/people/default-avatar.png';
  }

  getWhatsAppLink(number) {
    if (number) {
      let format = number.replace(/[^0-9]/g, '');
      return 'https://api.whatsapp.com/send?phone=' + format;
    }
    return false;
  }

  getAskRefundDate(datas){
    const t = JSON.parse(datas);
    return t.askDate;
  }
  getRefundedDate(datas){
    const t = JSON.parse(datas);
    return t.refundedDate;
  }
  getRefusedDate(datas){
    const t = JSON.parse(datas);
    return t.date;
  }

  filterOnInput() {
    if (this.searchSub$) {
      this.searchSub$.unsubscribe();
    }
    this.isLoadingDatas = true;
    this.searchSub$ = this.careService.getPayouts('housing-certificate', this.dataStatus, 1, this.sellSearchText).subscribe(
      data => {
        this.datas = data
        this.isLoadingDatas = false;
      }
    );
  }

  getPayoutPaymentLink(id:number) {
    this.careService.getPayoutPaymentLink(id).subscribe(data => {
      if (data) {
        if (data.toString().includes('stripe') || this.isProd) {
          window.open(data.toString(), '_blank');
        } else {
          if (!this.isProd) {
            const dataSplit = data.toString().split('/');
            const id = dataSplit[dataSplit.length - 1];
            window.open('https://www.sandbox.paypal.com/unifiedtransactions/details/payment/' + id, '_blank');
          }
        }
      }
    })
  }

}
